/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { reducerLogger } from "../../../../utility/reducerLogger";

export const scheduledReportsActions = {
	SCHEDULED_REPORT_LIST_GET: "SCHEDULED_REPORT_LIST_GET",
	SCHEDULED_REPORT_LIST_GET_SUCCESS: "SCHEDULED_REPORT_LIST_GET_SUCCESS",
	SCHEDULED_REPORT_LIST_GET_ERROR: "SCHEDULED_REPORT_LIST_GET_ERROR",

	SCHEDULED_REPORT_LIST_CLEAR_CHANGES: "SCHEDULED_REPORT_LIST_CLEAR_CHANGES",
	SCHEDULED_REPORT_LIST_UPDATE_CHANGES: "SCHEDULED_REPORT_LIST_UPDATE_CHANGES",

	SCHEDULED_REPORT_ADD_NEW: "SCHEDULED_REPORT_ADD_NEW",
	SCHEDULED_REPORT_UPDATE: "SCHEDULED_REPORT_UPDATE",
	SCHEDULED_REPORT_REMOVE: "SCHEDULED_REPORT_REMOVE",

	SCHEDULED_REPORT_LIST_UPDATE: "SCHEDULED_REPORT_LIST_UPDATE",
	SCHEDULED_REPORT_LIST_UPDATE_SUCCESS: "SCHEDULED_REPORT_LIST_UPDATE_SUCCESS",
	SCHEDULED_REPORT_LIST_UPDATE_ERROR: "SCHEDULED_REPORT_LIST_UPDATE_ERROR",
};

export const scheduledReportsInitialState = {
	reportLookup: [],
	scheduledReports: [],
	scheduledReportsBackup: [],
	scheduledReportsUpdates: {},
	loading: false,
	loaded: { scheduledReport: false, reportLookup: false },
	error: "",
	message: "",
};

const sortScheduledReports = (reports) => {
	return reports?.sort((prevSts, curSts) => (prevSts.reportName < curSts.reportName ? -1 : 1));
};

export const scheduledReportsReducer = reducerLogger((state, action) => {
	let newState = { ...state };
	let scheduledReports;
	let scheduledReportsUpdates;
	switch (action.type) {
		// Fetching already configured scheduled report from database.
		case scheduledReportsActions.SCHEDULED_REPORT_LIST_GET:
			newState = { ...state, scheduledReports: [], loading: true, error: "", scheduledReportsBackup: [], message: "" };
			return newState;
		case scheduledReportsActions.SCHEDULED_REPORT_LIST_GET_SUCCESS:
			scheduledReports = sortScheduledReports(action.payload);
			newState = {
				...state,
				scheduledReports: scheduledReports,
				scheduledReportsBackup: [...scheduledReports],
				scheduledReportsUpdates: {},
				loading: false,
				loaded: { ...state.loaded, scheduledReport: true },
				error: "",
				message: "",
			};
			return newState;
		case scheduledReportsActions.SCHEDULED_REPORT_LIST_GET_ERROR:
			newState = {
				...state,
				scheduledReports: [],
				scheduledReportsUpdates: {},
				loading: false,
				error: action.error,
				scheduledReportsBackup: [],
				message: "",
			};
			return newState;

		//Clearing changes from UI.
		case scheduledReportsActions.SCHEDULED_REPORT_LIST_CLEAR_CHANGES:
			newState = {
				...state,
				scheduledReports: state.scheduledReportsBackup,
				scheduledReportsUpdates: {},
				loading: false,
				error: "",
				message: "",
			};
			return newState;

		//Handling UI updates on state.
		case scheduledReportsActions.SCHEDULED_REPORT_LIST_UPDATE_CHANGES:
			newState = { ...state, scheduledReports: action.payload, loading: false, error: "" };
			return newState;

		//removing scheduled report from UI.
		case scheduledReportsActions.SCHEDULED_REPORT_REMOVE:
			scheduledReports = [...state.scheduledReports];
			scheduledReports.splice(action.index, 1);
			scheduledReportsUpdates = {
				...state.scheduledReportsUpdates,
				[action.payload.reportId]: { reportId: action.payload, activity: "DELETE" },
			};
			newState = { ...state, scheduledReports, scheduledReportsUpdates };
			return newState;

		// Handling UI Changes for a single report.
		case scheduledReportsActions.SCHEDULED_REPORT_UPDATE:
			scheduledReports = [...state.scheduledReports];
			if (action.payload.reportId !== "PACE_NEW_REPORT") {
				scheduledReportsUpdates = {
					...state.scheduledReportsUpdates,
					[action.payload.reportId]: { ...action.payload, activity: "UPDATE" },
				};
				if (
					scheduledReports[action.index].reportId !== "PACE_NEW_REPORT" &&
					scheduledReports[action.index].reportId !== action.payload.reportId &&
					state.scheduledReportsBackup.find((report) => report.reportId === scheduledReports[action.index].reportId)
				) {
					scheduledReportsUpdates = {
						...scheduledReportsUpdates,
						[scheduledReports[action.index].reportId]: {
							reportId: scheduledReports[action.index].reportId,
							activity: "DELETE",
						},
					};
				}
			}
			scheduledReports[action.index] = { ...action.payload };
			newState = { ...state, scheduledReports, scheduledReportsUpdates };
			return newState;

		//Adding new scheduled report
		case scheduledReportsActions.SCHEDULED_REPORT_ADD_NEW:
			scheduledReports = [action.payload, ...state.scheduledReports];
			newState = { ...state, scheduledReports };
			return newState;

		// Handle remote Database update calls.
		case scheduledReportsActions.SCHEDULED_REPORT_LIST_UPDATE:
			newState = { ...state, loading: true, error: "", message: "" };
			return newState;

		case scheduledReportsActions.SCHEDULED_REPORT_LIST_UPDATE_SUCCESS: // reset form changes to newly saved scheduled report.
			scheduledReports = sortScheduledReports(state.scheduledReports);
			newState = {
				...state,
				scheduledReports: scheduledReports,
				loading: false,
				error: "",
				scheduledReportsBackup: state.scheduledReports,
				scheduledReportsUpdates: {},
				message: "Successfully saved scheduled report.",
			};
			return newState;
		case scheduledReportsActions.SCHEDULED_REPORT_LIST_UPDATE_ERROR:
			newState = { ...state, loading: false, error: action.error, message: "" };
			return newState;
		default:
			return state;
	}
});
